import { GLOBAL_FETCH_SIGNAL, fetchUrl } from './settings';

import { ActionType } from '../action-types';
import _ from 'lodash';
import fetch from 'fetch-retry';
import { getVisibleSystemsForAccountShort } from './accountActions';

export const login = (formData) => (dispatch) => {
	fetch(`${fetchUrl}/login`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			const { token, name, email, accountCategory, ID } = data;
			localStorage.setItem('w4-token', token);
			return dispatch({
				type: ActionType.LOGIN_SUCCESS,
				token: token,
				username: name,
				loggedUserId: ID,
				email: email,
				accountCategory: accountCategory,
			});
		})
		.catch((error) => {
			return dispatch({
				type: ActionType.LOGIN_FAILED,
				error,
			});
		});
};

export const forgotPassword = (email) => (dispatch) => {
	fetch(`${fetchUrl}/remind-password/${email}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			return dispatch({
				type: ActionType.RESETTING_PASSWORD_SUCCEED,
			});
		})
		.catch((error) => {
			return dispatch({
				type: ActionType.RESETTING_PASSWORD_FAILED,
				error,
			});
		});
};

export const setCurrentNodeID = (newNodeId) => (dispatch) => {
	dispatch({
		type: ActionType.SET_CURRENT_NODE_ID,
		currentNodeId: newNodeId,
	});
};

export const showCard = () => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_CARD,
	});
};

export const closeError = () => (dispatch) => {
	dispatch({
		type: ActionType.CLOSE_ERROR,
	});
};

const fetcher = (endpoint) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/${endpoint}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};

const fetchSystems = () => {
	return fetcher('systems');
};

export const getNodes = (pickedSystemsIds = []) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	let systemsIds = pickedSystemsIds;

    return fetch(`${fetchUrl}/nodes`, {
        method: 'PATCH',
        signal: GLOBAL_FETCH_SIGNAL,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            systemIds: systemsIds,
        }),
        retries: 3,
        retryDelay: 500,
    })
        .then((resp) => {
            if (!resp.ok && resp.status !== 302) {
                throw new Error('FETCH ERROR');
            }
            return resp.json();
        })
        .then((data) => {
            const roleMap = {
                endpoint_device: 1,
                retransmitter: 2,
                access_device: 3,
                gateway: 4,
                unknown: 5,
            };
            const threatLevelMap = {
                L4: 1,
                L3: 2,
                L2: 3,
                L1: 4,
                none: 5,
                unknown_or_NA: 6,
            };
            if (!data) {
                data = [];
            }
            let parsedData = [];
            _.forEach(data, (el) => {
                el['deviceRoleSortable'] = roleMap[el.DeviceRole];
                el['deviceThreatLevelSortable'] = threatLevelMap[el.LatestKnownThreatLevel];
                parsedData.push(el);
            });

//             let sortedData = _.orderBy(parsedData, ['deviceRoleSortable', 'deviceThreatLevelSortable', 'name']);
            dispatch({
                type: ActionType.GET_NODES,
                nodes: parsedData,
            });
        })
        .catch((err) => {
            dispatch({
                type: ActionType.FETCH_ERROR,
                error: err,
            });
        });
};

export const getNodeById = (nodeId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/nodes/${nodeId}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 10,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_NODE,
				node: data
			});
		})
};

export const getNodeByIdShort = (nodeId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/nodes-short/${nodeId}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 10,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_NODE,
				node: data
			});
		})
};


export const clearNode = () => (dispatch) => {
	return dispatch({
        type: ActionType.CLEAR_NODE,
    });
};

export const toggleNotificationPopper = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_NOTIFICATION_POPPER,
	});
};

export const toggleChartType = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_CHART_TYPE,
	});
};

export const toggleLogoutPopper = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_LOGOUT_POPPER,
	});
};

export const gotoLogs = (gtl) => (dispatch) => {
	return dispatch({
		type: ActionType.GOTO_LOGS,
		gotoLogs: gtl,
	});
};


export function getSystems(dispatch) {
	return fetchSystems()
		.then((resp) => {
			// only an actual auth failure should log the user out - any other error (a
			// transient 5xx, a network blip, a bad deploy) used to log them out too, wiping
			// their whole session for no reason until they logged back in by hand
			if (resp.status === 401) {
				dispatch({ type: ActionType.LOGOUT });
				throw new Error('UNAUTHORIZED');
			}
			if (!resp.ok && resp.status !== 302) {
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEMS,
				systems: data,
			});
			let firstSystem = data[0];
			if (firstSystem) {
				dispatch({
					type: ActionType.FILTER_SYSTEMS,
					filter: [firstSystem.ID],
				});
			}
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
}
export const getSystems2 = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/systems`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (resp.status === 401) {
				dispatch({ type: ActionType.LOGOUT });
				throw new Error('UNAUTHORIZED');
			}
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEMS,
				systems: data,
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};


export const getSystemsForGroup = (systemGroupId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({
		type: ActionType.GET_SYSTEMS_FOR_GROUP,
		systems: [],
		groupId: 0
	});
	return fetch(`${fetchUrl}/system-groups/${systemGroupId}/systems`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (resp.status === 401) {
				dispatch({ type: ActionType.LOGOUT });
				throw new Error('UNAUTHORIZED');
			}
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEMS_FOR_GROUP,
				systems: data,
				groupId: systemGroupId
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const getUsersForSystemGroup = (systemGroupId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/system-groups/${systemGroupId}/accounts`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (resp.status === 401) {
				dispatch({ type: ActionType.LOGOUT });
				throw new Error('UNAUTHORIZED');
			}
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_ACCOUNTS_FOR_SYSTEM_GROUP,
				accounts: data,
				groupId: systemGroupId
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const getSystems3 = () => async (dispatch) => {
  dispatch({ type: ActionType.ARE_SYSTEMS_FETCHING, areSystemsFetching: true });
  let offset = 0;
  try {
    const token = localStorage.getItem('w4-token');
    const fetchSystems = async (offset) => {
      try {
        const resp = await fetch(`${fetchUrl}/systems/${offset}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await resp.json();

        if (data) {
          await dispatch({
            type: ActionType.FETCH_SYSTEMS,
            fetchedSystems: data,
	      });
	      if (data.length === 12) {
	        offset += 12;
	        setTimeout(fetchSystems(offset), 1000);
	      }
        } else {
          dispatch({ type: ActionType.ARE_SYSTEMS_FETCHING, areSystemsFetching: true });
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchSystems(offset);
  } catch (error) {
    console.error(error);
  }
};

export const getSystemsOverview = () => (dispatch) => {
	dispatch({ type: ActionType.GET_SYSTEMS_FOR_TABLE_START });
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/systems-table-view`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEMS_FOR_TABLE,
				systems: data,
			});
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.GET_SYSTEMS_FOR_TABLE_FAILED });
		});
};

export const clearSystemsForTable = () => (dispatch) => {
	dispatch({ type: ActionType.CLEAR_SYSTEMS_FOR_TABLE });
};

export const setProblemsConfirmed = (systemID, confirmed) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/system/confirm-problems`, {
        method: 'PATCH',
        signal: GLOBAL_FETCH_SIGNAL,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            systemId: systemID,
			confirmed: confirmed
        }),
        retries: 3,
        retryDelay: 500,
    })
	.then((resp) => {
		if (!resp.ok && resp.status !== 302) {
			throw new Error('FETCH ERROR');
		}
		return resp.json();
	})
	.then((data) => {
		// dispatch({
		// 	type: ActionType.SET_SYSTEM_PROBLEMS_CONFIRMED,
		// 	systemId: systemID,
		// 	succeeded: data.succeeded,
		// 	confirmedUntil: data.confirmedUntil
		// });
		return dispatch(getSystemsOverview());
	})
	.catch((err) => {
		console.error(err);
	});
};


export const isLoading = () => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_LOADING,
		isLoading: true,
	});

	var delay = new Promise(function (resolve) {
		setTimeout(function () {
			resolve(true);
		}, 2000);
	});

	Promise.all([getSystems(dispatch), delay]).then(() => {
		dispatch({
			type: ActionType.SHOW_LOADING,
			isLoading: false,
		});
		return Promise.resolve(true);
	});
};
export const exit = () => (dispatch) => {
	dispatch({ type: ActionType.LOGOUT });
	localStorage.setItem('w4-token', '');
};


export const accountsLoading = () => (dispatch) => {
	dispatch({ type: ActionType.ACCOUNTS_LOADING });
};

export const accountsLoaded = () => (dispatch) => {
	dispatch({ type: ActionType.ACCOUNTS_LOADED });
};

export const getVisibleAccounts = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/accounts`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			} else {
				let accounts = [];
				_.forEach(data, (account) => {
					if (account.systems.Valid) {
						let ids = account.systems.String.split(',').map((id) => parseInt(id, 10));
						account.systems = ids;
					} else {
						account.systems = [];
					}
					accounts.push(account);
				});
				data = accounts;
			}
			// data = accounts;
			// TODO: wysłać zapytanie o widoczne konta
			// TODO: ustawić pobrane konta
			// TODO: ustawić właściwe konto jako aktywnie edytowane
			dispatch({
				type: ActionType.GET_VISIBLE_ACCOUNTS,
				accounts: data,
			});
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};

export const setClickedButtonDisabled = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_DISABLE_BUTTON,
		clickedButtonEnabled: false,
	});
};

export const setClickedSendButtonDisabled = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_DISABLE_SEND_BUTTON,
		clickedSendButtonDisabled: true,
	});
};

export const setClickedSendButtonEnabled = () => (dispatch) => {
	return dispatch({
		type: ActionType.TOGGLE_DISABLE_SEND_BUTTON,
		clickedSendButtonDisabled: false,
	});
};


export const closeEmptySystemError = () => (dispatch) => {
	return dispatch({ type: ActionType.CLOSE_EMPTY_SYSTEM_ERROR, nodes: [] });
};

export const getSyncFailures = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/sync-failures`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYNC_FAILURES,
				syncFailures: data,
			});
		})
		.catch((err) => {
			console.error(err);
		});
};

export const getDeviceErrors = ({
	limit = 25,
	offset = 0,
	sortField = 'timestamp',
	sortOrder = -1,
	systemId = null,
	nodeId = null,
	deviceId = null,
	serialNumber = null,
	errorMessage = null,
	dateStart = null,
	dateEnd = null,
} = {}) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.DEVICE_ERRORS_LOADING });
	return fetch(`${fetchUrl}/device-errors`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			limit,
			offset,
			sortField,
			sortOrder,
			systemId: systemId || null,
			nodeId: nodeId || null,
			deviceId: deviceId || null,
			serialNumber: serialNumber || null,
			errorMessage: errorMessage || null,
			dateStart: dateStart || null,
			dateEnd: dateEnd || null,
		}),
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({
				type: ActionType.GET_DEVICE_ERRORS,
				deviceErrors: data?.DeviceErrors || [],
			});
		})
		.catch((err) => {
			console.error(err);
			dispatch({
				type: ActionType.GET_DEVICE_ERRORS,
				deviceErrors: [],
			});
		});
};

export const exportDeviceErrors = (
	{
		systemId = null,
		nodeId = null,
		deviceId = null,
		serialNumber = null,
		errorMessage = null,
		dateStart = null,
		dateEnd = null,
	} = {},
	signal?: AbortSignal
) => () => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/device-errors-export`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		signal,
		body: JSON.stringify({
			systemId: systemId || null,
			nodeId: nodeId || null,
			deviceId: deviceId || null,
			serialNumber: serialNumber || null,
			errorMessage: errorMessage || null,
			dateStart: dateStart || null,
			dateEnd: dateEnd || null,
		}),
	}).then((resp) => {
		if (!resp.ok) {
			throw new Error('Failed to export device errors');
		}
		return resp.blob();
	});
};

export const getDeviceErrorsCount = ({
	systemId = null,
	nodeId = null,
	deviceId = null,
	serialNumber = null,
	errorMessage = null,
	dateStart = null,
	dateEnd = null,
} = {}) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/device-errors-count`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			systemId: systemId || null,
			nodeId: nodeId || null,
			deviceId: deviceId || null,
			serialNumber: serialNumber || null,
			errorMessage: errorMessage || null,
			dateStart: dateStart || null,
			dateEnd: dateEnd || null,
		}),
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({
				type: ActionType.GET_DEVICE_ERRORS_COUNT,
				deviceErrorsCount: data?.DeviceErrorsCount || 0,
			});
		})
		.catch((err) => {
			console.error(err);
			dispatch({
				type: ActionType.GET_DEVICE_ERRORS_COUNT,
				deviceErrorsCount: 0,
			});
		});
};